import { apiRequest } from './apiClient';

/** Personal UI settings of the signed-in employee, keyed by setting name. Values are client-owned JSON. */
export type UiPreferences = {
  employeeId: string;
  preferences: Record<string, unknown>;
  updatedAt: string | null;
};

export const UI_PREFERENCE_KEYS = {
  sidebarLayout: 'sidebarLayout',
} as const;

const normalize = (payload: any): UiPreferences => ({
  employeeId: typeof payload?.employeeId === 'string' ? payload.employeeId : '',
  preferences: payload?.preferences && typeof payload.preferences === 'object' ? payload.preferences : {},
  updatedAt: typeof payload?.updatedAt === 'string' ? payload.updatedAt : null,
});

export const uiPreferencesService = {
  getMine: async (): Promise<UiPreferences> => {
    const payload = await apiRequest<any>('/api/v1/employees/me/ui-preferences');
    return normalize(payload);
  },

  /** Partial update. Pass `null` for a key to remove it on the server. */
  updateMine: async (preferences: Record<string, unknown | null>): Promise<UiPreferences> => {
    const payload = await apiRequest<any>('/api/v1/employees/me/ui-preferences', {
      method: 'PATCH',
      body: JSON.stringify({ preferences }),
    });
    return normalize(payload);
  },
};
